import { range } from '~/utils/helpers'

import { ActivityNames } from './types'

export function getRanges(
  key: ActivityNames,
  difficultyLevel: number,
): {
  ranges: number[]
  termsCount: number
} {
  let termsCount: number
  let ranges: number[]

  const l1 = [1, 2, 3, 4, 5, 10]
  const l2 = range(10).map((elem) => elem + 1)
  const l3 = range(6).map((elem) => elem + 6)

  switch (key) {
    case 'MANY_NEGATIVE_1':
      termsCount = 3

      switch (difficultyLevel) {
        case 1:
          ranges = l1
          break

        case 2:
          ranges = l2
          break

        case 3:
          ranges = l3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    case 'MANY_NEGATIVE_2':
      termsCount = 4

      switch (difficultyLevel) {
        case 1:
          ranges = l1
          break

        case 2:
          ranges = l2
          break

        case 3:
          ranges = l3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    case 'MANY_NEGATIVE_3':
      termsCount = 5

      switch (difficultyLevel) {
        case 1:
          ranges = l1
          break

        case 2:
          ranges = l2
          break

        case 3:
          ranges = l3
          break

        default:
          throw new Error(`Invalid difficulty level: ${difficultyLevel}`)
      }
      break

    default:
      throw new Error(`Invalid key: ${key}`)
  }

  return {
    ranges,
    termsCount,
  }
}
